import React from 'react';
import { ANSWER_TYPES, QuestionData } from 'src/types/formQuestionnaire';
import { PreviewAction, QuestionAnswer } from './FormPreview.reducer';
import {
  AttachmentInput,
  CheckboxInput,
  DatabaseFieldInput,
  DataGridInput,
  DateTimeInput,
  DropdownMultiInput,
  DropdownSingleInput,
  LongTextInput,
  NumericInput,
  RadioInput,
  ShortTextInput,
} from './inputs';

interface Props {
  currentQuestion: QuestionData;
  answers: Record<string, QuestionAnswer>;
  dispatch: React.Dispatch<PreviewAction>;
  handleFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDeleteFile: (fileId: string) => void;
  handleFileDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  fileInputId: string;
  inlinePlacement?: 'standard' | 'formManagement';
  textInputPlaceholder: string;
  dropdownPlaceholder: string;
  databaseFieldLabel: string;
  databaseFieldPlaceholder: string;
}

export const QuestionInput = ({
  currentQuestion,
  answers,
  dispatch,
  handleFileSelect,
  handleDeleteFile,
  handleFileDrop,
  fileInputId,
  inlinePlacement,
  textInputPlaceholder,
  dropdownPlaceholder,
  databaseFieldLabel,
  databaseFieldPlaceholder,
}: Props) => {
  const baseProps = {
    currentQuestion,
    answers,
    dispatch,
    inlinePlacement,
    textInputPlaceholder,
    dropdownPlaceholder,
    databaseFieldLabel,
    databaseFieldPlaceholder,
  };

  switch (currentQuestion.questionType) {
    case ANSWER_TYPES.SHORT_TEXT:
      return <ShortTextInput {...baseProps} />;

    case ANSWER_TYPES.LONG_TEXT:
      return <LongTextInput {...baseProps} />;

    case ANSWER_TYPES.RADIO:
      return <RadioInput {...baseProps} />;

    case ANSWER_TYPES.CHECKBOX:
      return <CheckboxInput {...baseProps} />;

    case ANSWER_TYPES.DROPDOWN_SINGLE:
      return <DropdownSingleInput {...baseProps} />;

    case ANSWER_TYPES.DROPDOWN_MULTI:
      return <DropdownMultiInput {...baseProps} />;

    case ANSWER_TYPES.DATA_GRID:
      return <DataGridInput {...baseProps} />;

    case ANSWER_TYPES.ATTACHMENT:
      return (
        <AttachmentInput
          {...baseProps}
          handleFileSelect={handleFileSelect}
          handleDeleteFile={handleDeleteFile}
          handleFileDrop={handleFileDrop}
          fileInputId={fileInputId}
        />
      );

    case ANSWER_TYPES.DATE_PICKER:
    case ANSWER_TYPES.TIME_PICKER:
      return <DateTimeInput {...baseProps} />;

    case ANSWER_TYPES.NUMERIC:
      return <NumericInput {...baseProps} />;

    case ANSWER_TYPES.DATABASE_FIELD:
      return <DatabaseFieldInput {...baseProps} />;

    default:
      return null;
  }
};
